import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { first, map, Observable, Subject, switchMap } from 'rxjs';

import { AUTH_TOKEN } from '../../common/auth/auth-token.interceptor';
import { AuthService } from '../../common/auth/auth.service';
import { AbstractFetchAdaptor } from '../../common/fetch/abstract-fetch.adaptor';
import { API_BASE_URL } from '../../core/interceptors/base-path.interceptor';
import { HOST_URL } from '../../core/services/api-host-url.token';
import { IScreeningToolSection } from './interfaces/screening-tool.interface';

export interface ScreeningToolsResponse {
  sections: IScreeningToolSection[];
}

@Injectable()
export class ScreeningToolsAdaptor extends AbstractFetchAdaptor<object, ScreeningToolsResponse> {
  override name = 'screening-tools';

  private baseUrl = inject(HOST_URL);
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  private apiBaseURL = inject(API_BASE_URL);

  private sectionToolsUrl = `${this.apiBaseURL}/sections.json`;
  data$ = new Subject<ScreeningToolsResponse>();

  override onRequest(): Observable<ScreeningToolsResponse> {
    return this.auth.token$.pipe(
      first(),
      switchMap((token) =>
        this.http.get<ScreeningToolsResponse>(this.sectionToolsUrl, {
          context: new HttpContext().set(AUTH_TOKEN, token),
        }),
      ),
      map((res) => {
        res.sections.forEach((section) => {
          section.image = this.baseUrl + section.image;
        });
        return res;
      }),
    );
  }

  override onSuccess(_props: object, res: ScreeningToolsResponse) {
    this.data$.next(res);
  }
}
